/* Display portraits only; independent of uploaded photos and generation state. */
if (!customElements.get('home-hero-photo')) {
  customElements.define('home-hero-photo', class extends HTMLElement {
    connectedCallback() {
      this.photo = this.querySelector('img');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wide = window.matchMedia('(min-width: 1600px)');
      this.secondPhoto = new Image();
      this.secondPhoto.src = this.dataset.secondSrc;
      this.update = () => {
        window.clearInterval(this.timer);
        this.firstSrc = this.wide.matches && this.dataset.wideFirstSrc ? this.dataset.wideFirstSrc : this.dataset.firstSrc;
        this.photo.src = this.firstSrc;
        if (this.motion.matches || document.hidden) return;
        this.timer = window.setInterval(() => {
          if (!this.secondPhoto.complete || !this.secondPhoto.naturalWidth) return;
          this.photo.src = this.photo.getAttribute('src') === this.firstSrc
            ? this.dataset.secondSrc : this.firstSrc;
        }, 2000);
      };
      this.motion.addEventListener('change', this.update);
      this.wide.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      this.update();
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.motion.removeEventListener('change', this.update);
      this.wide.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
}
